module.exports = __webpack_public_path__ + "static/media/faq-min.c35b0a93.svg";